/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {DomAdapter} from './dom-adapter';
import {DatagridRenderOrganizer} from './render-organizer';
export class DatagridBodyRenderer implements OnDestroy {
/**
 * @param {?} el
 * @param {?} organizer
 * @param {?} domAdapter
 */
constructor(private el: ElementRef,
private organizer: DatagridRenderOrganizer,
private domAdapter: DomAdapter) {
        this.subscription = organizer.scrollbar.subscribe(() => this.computeScrollbarWidth());
    }
private subscription: Subscription;
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscription.unsubscribe();
    }
/**
 * @return {?}
 */
private computeScrollbarWidth() {
        this.organizer.scrollbarWidth.next(this.domAdapter.scrollBarWidth(this.el.nativeElement));
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrDgBody]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: DatagridRenderOrganizer, },
{type: DomAdapter, },
];
}

function DatagridBodyRenderer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridBodyRenderer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridBodyRenderer.ctorParameters;
/** @type {?} */
DatagridBodyRenderer.prototype.subscription;
/** @type {?} */
DatagridBodyRenderer.prototype.el;
/** @type {?} */
DatagridBodyRenderer.prototype.organizer;
/** @type {?} */
DatagridBodyRenderer.prototype.domAdapter;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
